"use strict";
const pwmFormSelect = () => {
	const selectElements = document.querySelectorAll('._pwm_select');

	const closeSelect = () => {
		const select = document.querySelectorAll('.pw-m-select');
		const overlay = document.querySelectorAll('.pw-m-select__overlay');
		for (let i = 0; i < overlay.length; i++) {
			overlay[i].remove();
		}
		for (let i = 0; i < select.length; i++) {
			select[i].classList.remove('_open');
		}
	}

	const changeSelect = (e) => {
		let target = e.target;
		let closestElem = target.closest('.pw-m-select');
		const selectElement = document.querySelector('select[name="' + closestElem.dataset.name + '"]');
		closestElem.querySelector('.pw-m-select__value').dataset.value = target.dataset.value;
		closestElem.querySelector('.pw-m-select__value').innerHTML = target.innerText;
		target.classList.add('pw-m-select__item-active');
		for (let i = 0; i < selectElement.options.length; i++) {
			selectElement.options[i].removeAttribute('selected');
			if (selectElement.options[i].label === target.dataset.value) {
				selectElement.options[i].setAttribute('selected', 'selected');
			}
		}
		setTimeout(function () {
			closeSelect();
		}, 500);

	}

	const openSelect = (e) => {
		const target = e.target;
		const ifOverlay = document.querySelector('.pw-m-select__overlay');
		if (ifOverlay) {
			ifOverlay.remove();
		}
		const overlay = '<div class="pw-m-select__overlay"></div>'
		if (target.closest('.pw-m-select')) {
			target.closest('.pw-m-select').insertAdjacentHTML('beforeBegin', overlay);
			target.closest('.pw-m-select').classList.toggle('_open');

			document.querySelector('.pw-m-select__overlay').addEventListener('click', closeSelect);
		}
		/*if (target.classList.contains('.pw-m-select')) {
		  let elem = target.closest('.pw-m-select');
		  console.log(2);
		  elem.classList.toggle('_open');
		}*/
	}

	const addChangeSelect = () => {
		const pwmSelect = document.querySelectorAll('.pw-m-select');
		for (let i = 0; i < pwmSelect.length; i++) {
			pwmSelect[i].addEventListener('click', openSelect);
		}
		const pwmSelectItem = document.querySelectorAll('.pw-m-select__item');
		for (let i = 0; i < pwmSelectItem.length; i++) {
			pwmSelectItem[i].addEventListener('click', changeSelect);
		}
	}

	const createSelect = (elem) => {
		let collection = elem.options;

		let selectOptions = [];
		for (let i = 0; i < collection.length; i++) {
			if (collection[i].defaultSelected === true) {
				selectOptions[i] = {
					id: i,
					label: collection[i].label,
					value: collection[i].innerHTML.trim(),
					selected: collection[i].defaultSelected,
				}
			} else {
				selectOptions[i] = {
					id: i,
					label: collection[i].label,
					value: collection[i].innerHTML.trim(),
				}
			}
		}

		const template = `
  <div class="pw-m-select" data-name="${elem.name}">
      <div class="pw-m-select__selected">
          <span class="pw-m-select__value" data-value="${selectOptions[0].label}">${selectOptions[0].value}</span>
<span class="pw-m-select__arrow icon-arrow"></span>
      </div >
  <ul class="pw-m-select__list">
    ${selectOptions.map(option => `
          <li class="pw-m-select__item" data-value="${option.label}">${option.value}</li>
          `).join('')}
  </ul>
  </div >
  `;

		elem.insertAdjacentHTML('afterEnd', template);

		addChangeSelect();
	}

	for (let i = 0; i < selectElements.length; i++) {
		selectElements[i].classList.add('_hide');
		createSelect(selectElements[i]);
	}
}
pwmFormSelect();